import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Sedes, OrdenMedicaSinAgendaEntity, OrdenMedicaSinAgendaBodyEntity, ServicioLaboratorioService } from 'src/app/services/servicio-laboratorio.service';
import { FileService } from 'src/app/services/utils/file.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-header-ordenes-sin-agenda',
  templateUrl: './header-ordenes-sin-agenda.component.html',
  styleUrls: ['./header-ordenes-sin-agenda.component.css']
})
export class HeaderOrdenesSinAgendaComponent implements OnInit {

  canDownload: boolean; // Indicador que existe data
  loading: boolean; // Indicador de carga en header
  downloading: boolean; // Indicado de descarga en header
  fechaInicial: string; // Valor fecha inicial del formulario
  fechaFinal: string; // Valor fecha final del formulario
  sede: number // Sede seleccionada
  mensajeError: string; // Mensaje de error

  sedes: Sedes[]; // lista sedes

  @Input() public objectOrdenSinCitaEntity: OrdenMedicaSinAgendaEntity;
  @Input() public objectOrdenesBodySinCitaEntity: OrdenMedicaSinAgendaBodyEntity[];
  @Output() filtrosSeleccionados: EventEmitter<OrdenMedicaSinAgendaEntity>;

  constructor( private servicioLaboratorio: ServicioLaboratorioService,
               private servicioArchivo: FileService,
               private servicioFecha: FechaService,
               private servicioExcel: ExcelService) { 
    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  async init(){
    if(!this.sedes || this.sedes.length === 0){
      if(this.objectOrdenSinCitaEntity && this.objectOrdenSinCitaEntity.sede != 0){
        this.sede = Number(this.objectOrdenSinCitaEntity.sede);
      }else{
        this.sede = 0;
      }
      this.fechaInicial = this.servicioFecha.getInputValue(new Date().getTime());
      this.fechaFinal = this.servicioFecha.getInputValue(new Date().getTime());
      this.getSedes();
    }
  }

  async getSedes(){
    try{
      let response = await this.servicioLaboratorio.getSedesOrdenesMedicasSinAgenda(this.objectOrdenSinCitaEntity);
      if(response != null){
        response.subscribe((data: Sedes[]) => {
          this.sedes = data;
          this.onGenerar();
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error('Error getSedes()', err);
          this.sedes = [];
          this.loading = false;
        })
      }
    }catch(e){
      console.error('header-ordenes-sin-agenda.getSedes()', e);
    }
  }

  onGenerar(){
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    let obj: OrdenMedicaSinAgendaEntity = {
      codigo : this.objectOrdenSinCitaEntity.codigo,
      fechaInicial : 0,
      fechaFinal : 0,
      sede : 0,
      descripcionSede : ''
    }

    if(inicio === null || inicio.getTime() === 0){
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    }else if(fin === null || fin.getTime() === 0 ){
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    }else if(Number(this.sede) === 0){
      this.mostrarMensaje('Debe seleccionar el campo <strong>Sede</strong>.');
    }else if(this.servicioFecha.compare(inicio, fin) == 1){
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    }else{
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.sede = Number(this.sede);
      obj.descripcionSede = this.getSede(Number(this.sede));

      this.objectOrdenSinCitaEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
    }
    this.filtrosSeleccionados.emit(obj);

  }

  onImprimir(){
    let printContents: any, popupWin: any;

    printContents = document.getElementById('ordenes-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF(){
    try{
      if(this.validatePDF()){
        this.downloading = true;
        let data =  xepOnline.Formatter.Html('ordenes-print',{resolution : '200'});
        const html = `<!DOCTYPE html><head><meta charset="UTF-8"/><title>Citas Laboratorio</title></head><body>${data}</body></html>`;

        let response = this.servicioArchivo.generatePDF(html, 'Ordenes Sin Agenda', 'ordenesSinAgenda');

        response.subscribe((data: any) => { 
          let filename = data.filename;
          this.servicioArchivo.downloadFile(filename)
          .subscribe((data) =>{
            saveAs(data, filename);
            this.downloading = false;
          }, err => {
            this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
            console.error('Error download', err);
            this.downloading = false;
          })
        }, (err: HttpErrorResponse) => {
          console.error('Error', err);
          this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
          this.downloading = false;
        });
      }
    }catch(e){
      console.error(e);
      this.downloading = false;
      this.mostrarMensaje('Error al intentar generar pdf, reporte caso al administrador');
    }
  }

  onDescargarExcel(){
    this.downloading = true;
    let initialData: OrdenMedicaSinAgendaBodyEntity[] = this.objectOrdenesBodySinCitaEntity;
    let finalData: any[] = [];
    
    if(initialData && initialData.length > 0){
      initialData.forEach((d: OrdenMedicaSinAgendaBodyEntity) => {
        let data : any = {
          sede : d.sede,
          numeroOrden : d.numeroOrden,
          fechaAtencion: this.servicioFecha.getDateTimeValue(new Date(d.fechaAtencion)),
          tipoIdentificacion : d.codigoDocumento,
          numeroIdentificacion : d.numeroDocumento,
          paciente: d.primerNombre + ' ' + d.segundoNombre + ' ' + d.primerApellido + ' ' + d.segundoApellido,
          telefono : d.telefono,
          medico : d.nombresProfesional + ' ' + d.apellidosProfesional,
          cantidad : d.cantidad
        };
        finalData.push(data);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'ordenesSinAgenda', 'Ordenes Médicas sin Agenda');
      this.downloading = false;
    }else{
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }
  }

  // Auxiliares

  getSede(unco: number):string {
    if(unco === -1){
      return 'Todas las sedes';
    }else{
      let sde = this.sedes.find((s: Sedes) => {
        return s.unco === unco;
      });
      return sde ? (sde.descripcionCorta ? sde.descripcionCorta : sde.descripcion) : '--';
    }
  }

  validatePDF(){
    if(!this.objectOrdenesBodySinCitaEntity || this.objectOrdenesBodySinCitaEntity.length < 500){
      return true;
    }else{
      this.mostrarMensaje('El reporte supera los 500 registros, por favor genere un archivo excel.');
      return false; 
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 3500);
  }

}
